import produce from 'immer';

import { Types, consultaEPortalAutomatizado } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: consultaEPortalAutomatizado = {
	status: 0,
	data: null,
};

export default function consultaEPortalAutomatizadoReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultaEPortalAutomatizado {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_E_PORTAL_AUTOMATIZADO_REQUEST: {
				break;
			}
			case Types.CONSULTA_E_PORTAL_AUTOMATIZADO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_E_PORTAL_AUTOMATIZADO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_E_PORTAL_AUTOMATIZADO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
	});
}
